<!--
  * @FileDescription: 自定义点击按钮上传文件
  * @Author: 朱建波
  * @Date: 2026-03-09
 * @LastEditors: 朱建波 342393950@qq.com
  *
  * @name: ZUBtnUpload
  *
  * @Props
  * @property {String} src                  文件地址
  * @property {String} text                 按钮文字
  * @property {String} code                 后端定义的状态码
  * @property {String} name                 后端定义的name
  * @property {Object} data                 额外添加上传数据
  * @property {Number} data.type            上传类型  1 'images'公共图片,2 'bucket_template' 模版,3 'recruit-image' 招生
  * @property {Number} data.use_outer_url   携带带域名  1 携带 0 不携带
  * @property {Boolean} readonly            是否只读
  * @property {Boolean} showLoading         是否显示loading
  * @property {Boolean} showImg             是否全屏展示图片
  * @property {Function} beforeUpload       自定义上传前置函数
  * @property {Function} onSuccess          自定义上传成功函数
  * @property {Function} onError            自定义上传失败函数
  *
  * @Slots
  *
  * @Methods
  * change 列表数据改变钮触发事件  全部 status 为 uploaded/success 时 全部上传完成
  -->
<script>
import ImageViewer from '@/components/common/ImageViewer'
import { fileUpload } from '@/api'
export default {
  props: {
    src: { type: String, default: '' },
    accept: { type: String, default: '' }, // image/*
    type: { type: String, default: 'img' }, // img 图片  file 文件
    text: { type: String, default: '上传文件' },
    repeatText: { type: String, default: '重新上传' },
    loadingText: { type: String, default: '上传中...' },
    icon: { type: String, default: 'el-icon-upload2' },
    code: { type: [String, Number], default: 0 },
    name: { type: String, default: 'upload' },
    data: { type: Object, default: () => ({ type: 1, use_outer_url: 1 }) },
    readonly: { type: Boolean, default: true },
    showLoading: { type: Boolean, default: true },
    showImg: { type: Boolean, default: true },
    file_addr: { type: String, default: 'file_addr' },
    beforeUpload: Function,
    onSuccess: Function,
    onError: Function,
  },
  components: { ImageViewer },
  data() {
    return {
      showSrc: '',
      controller: null,
      loading: false,
      title: '',
      progress: 0,
      status: 'waiting', // waiting 等待中 uploading 上传中 success 上传成功 error 上传失败 cancelled 上传取消
      response: null,
      visible: false,
    }
  },
  computed: {
    newAccept() {
      if (this.accept) return this.accept
      let str = ''
      if (this.type === 'img') {
        str = 'image/*'
      } else if (this.type === 'ppt') {
        str = 'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation'
      } else if (this.type === 'word') {
        str = 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      } else if (this.type === 'excel') {
        str = 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      } else if (this.type === 'pdf') {
        str = 'application/pdf'
      }
      return str
    },
    showUrl() {
      return this.showSrc || this.src
    },
    showText() {
      if (this.status === 'uploading') return this.loadingText
      else if (['success', 'error', 'cancelled'].includes(this.status)) return this.repeatText
      const txt = this.text || '上传文件'
      return txt
    }
  },
  watch: {
    src: {
      immediate: true,
      handler(val) {
        if (!val) return
        this.showSrc = val
        this.status = 'success'
      }
    },
  },
  beforeDestroy() {
    if (this.controller) {
      this.controller.abort()
    }
    if (this.showSrc) {
      URL.revokeObjectURL(this.showSrc)
      this.showSrc = null
    }
  },
  methods: {
    // 选择图片
    handleChoose() {
      this.$refs.fileRef.dispatchEvent(new MouseEvent('click'))
    },
    //获取选择文件
    handleChangeFile(event){
      this.handleFiles(event.target.files)
    },
    handleFiles(files) {
      let message = ''
      if (this.beforeUpload) {
        message = this.beforeUpload(files[0])
      }
      if (message) {
        this.$refs.fileRef.value = ''
        return this.$message({ type: 'warning', duration: 2000, message })
      }
      this.handleRequest(files[0])
    },
    // 展示进度文字信息
    showProgressText(progress) {
      if (typeof progress === 'number') {
        return progress + '%'
      }
      return progress
    },
    showProgress(data) {
      const { progress } = data
      this.progress = progress
      this.$emit('progress', progress)
    },
    handleRequest(file) {
      if (!file) return
      if (!this.controller) {
        this.controller = new AbortController()
      }
      const controller = this.controller
      const blob = new Blob([file], { type: file.type })

      this.title = file.name
      this.showSrc = URL.createObjectURL(blob)
      this.progress = 0
      this.status = 'uploading'
      this.response = null
      this.loading = true
      console.log(file);

      let formData = new FormData()
      formData.append(this.name, file)
      Object.keys(this.data).forEach(key => {
        formData.append(key, this.data[key])
      })
      fileUpload('/api2/api/site/upload', formData, { callback: this.showProgress, controller, origin: 1 }).then(response => {
        if (this.onSuccess) {
          this.onSuccess(response)
        }
        const { status, msg, data } = response
        // 自定义成功状态
        if (Number(this.code) === Number(status)) {
          // 成功状态
          if (this.progress !== 100) {
            this.progress = 100
          }
          this.controller = null
          this.status = 'success'
          this.response = data
          this.$emit('success', data)
          this.$emit('change', data[this.file_addr])
        } else {
          this.$message.error(msg)
          this.status = 'error'
        }
      }).catch(err => {
        if (this.onError) {
          this.onError(err)
        }
        this.progress = 0
        // 取消状态
        if (err?.message === 'canceled') {
          this.status = 'canceled'
          return
        }
        // 失败状态
        this.status = 'error'
        this.response = err
        this.$emit('error', err)
      }).finally(() => {
        this.loading = false
        this.$refs.fileRef.value = ''
      })
    },
    handlePreview() {
      if (this.accept && !this.accept.includes('image')) return
      if (!this.showImg || this.type !== 'img') return
      this.visible = true
    },
    handleDelete() {
      URL.revokeObjectURL(this.showSrc)
      this.showSrc = ''
      this.progress = 0
      this.title = ''
      this.controller = null
      this.status = 'waiting'
      this.response = null
      this.$emit('change', '')
    },
    handleRemove() {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete()
          done()
        }
      }).then(() => {
        this.$message({type: 'success', message: `删除成功!`})
      })
    }
  }
}
</script>

<template>
  <div class="zu-button-upload-wrapper">
    <el-button type="primary" plain :icon="icon" @click="handleChoose" :loading="loading">{{ showText }}</el-button>
    <div class="zu-button-upload-loading" v-if="showLoading && loading">
      <div class="text">{{ showProgressText(progress) }}</div>
      <div class="bg">
        <div class="progress" :style="{ width: progress + '%' }"></div>
      </div>
    </div>
    <div class="zu-button-upload-info" v-if="status === 'success'">
      <div class="name" @click="handlePreview">
        <div class="title" :class="{ cur: showImg }">{{ title }}</div>
        <i class="el-icon-error zu-icon" :class="{ cur: showImg }" @click.stop="handleRemove"></i>
      </div>
    </div>
    <div class="zu-button-upload-hidden">
      <input ref="fileRef" type="file" placeholder="请选择上传文件" @change="handleChangeFile" :accept="newAccept" />
    </div>
    <image-viewer :list="[showUrl]" :visible.sync="visible"/>
  </div>
</template>

<style lang="scss" scoped>
.zu-button-upload {
  &-wrapper {
    display: flex;
    flex-direction: column;
  }
  &-loading {
    .bg {
      height: 4rem;
      background-color: #8c939d;
    }
    .progress {
      height: 100%;
      background-color: #409eff;
    }
  }
  &-info {
    .name {
      position: relative;
      height: 20rem;
      margin-top: 10rem;
      padding: 0 20rem 0 10rem;
      font-size: 12rem;
      color: #444;
      background-color: #F3F3F3;
      border-radius: 20rem;
      .zu-icon {
        position: absolute;
        right: -4rem;
        top: -4rem;
        color: #000;
        font-size: 16rem;
        &:hover {
          color: #f56c6c;
        }
      }
    }
    .title {
      line-height: 20rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .cur {
      cursor: pointer;
      &:hover {
        color: #409eff;
      }
    }
  }
  &-hidden {
    display: none;
  }
}
</style>
